import { ApiClient, ApiError, ApiSession } from '../clients/api';
import { FirebaseAuthenticationClient } from '../clients/firebase-authentication';
import { LoggerHelper } from '../helpers';
import { UserModel } from '../models/user.model';

/**
 * Resolve o perfil do usuario logado pelo backend.
 *
 * A autenticacao continua sendo do Firebase; o que o backend decide e a
 * autorizacao, lendo CoreUsers com o Admin SDK. O e-mail usado na busca sai do
 * ID token, nunca de um parametro do cliente.
 */
class SessionService {
  static async resolve(): Promise<UserModel | null> {
    try {
      const session = await ApiClient.post<ApiSession>('/auth/session');

      if (session.claimsUpdated) {
        // Sem isto as claims recem-gravadas so valeriam no proximo refresh
        // automatico, ate 1h depois, e o RTDB negaria o acesso ate la.
        await FirebaseAuthenticationClient.getIdToken(true);
      }

      return SessionService.toUserModel(session);
    } catch (error) {
      // 403 e a resposta legitima para quem autentica mas nao tem perfil.
      if (error instanceof ApiError && error.isForbidden) return null;

      LoggerHelper.error('Falha ao resolver sessao pela API', error);
      throw error;
    }
  }

  private static toUserModel(session: ApiSession): UserModel {
    return {
      id: session.userId,
      email: session.email,
      name: session.name,
      namePrefix: session.namePrefix,
      permission: session.permission,
      projects: session.projects,
    } as UserModel;
  }
}

export { SessionService };
